import React from "react";
import { Link } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../hooks";
import { logout } from "../../features/user/userSlice";
import { clear } from "../../features/todo/todoSlice";

function Navbar() {
  const user = useAppSelector((state) => state.user.token);
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logout());
    dispatch(clear())
  };

  return (
    <nav>
      <h1>To Do App</h1>
      <div>
        <Link to="/">Home</Link>
        {user ? (
          <>
            <Link to="/todos">Todos</Link>
            <Link to="/settings/profile">Settings</Link>
            <button className="btn-primary" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login">Login</Link>
            <Link to="/signup">Signup</Link>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
